import React, { useState } from "react";
import moment from "moment";

import calculateTime from "../../../utils/calculateTime";
import airarabiaLogo from "../../../images/flight-logo/airarabia.png";

const FlightPricingItemAirArabia = ({
  flights,
  oneWayLength,
  bookingDetails,
  cabin,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const renderDetailTop = (flightInfo, index, showButton) => {
    return (
      <div>
        <div className="flex flex-col md:flex-row">
          <div className="flex-shrink-0 mt-10 w-24 md:w-20 md:pt-7">
            <img src={airarabiaLogo} className="w-15" alt="" />
          </div>
          <div className="flex my-3 md:my-0 lg:w-40">
            <div className="flex flex-col flex-shrink-0 items-center py-2">
              <span className="block w-6 h-6 rounded-full border border-neutral-400"></span>
              <span className="block flex-grow my-1 border-l border-dashed border-neutral-400"></span>
              <span className="block w-6 h-6 rounded-full border border-neutral-400"></span>
            </div>
            <div className="ml-4 space-y-20 text-base">
              <div className="flex flex-col space-y-1">
                <span className="font-extralight text-black">
                  {moment(flightInfo?.departureDateTime).format("HH:mm")}
                </span>
                <span className="font-semibold text-black">
                  {flightInfo?.departureAirport?.code}
                </span>
              </div>
              <div className="flex flex-col space-y-1">
                <span className="font-extralight text-black">
                  {moment(flightInfo?.arrivalDateTime).format("HH:mm")}
                </span>
                <span className="font-semibold text-black">
                  {flightInfo?.arrivalAirport?.code}
                </span>
              </div>
            </div>
          </div>
          <div className="mt-1 border-l border-neutral-200 md:mx-6 lg:mx-10"></div>
          <div className="flex flex-col gap-3 justify-between">
            <div className="flex gap-3">
              <div className="space-y-1 text-base font-extralight text-black md:space-y-2">
                <div>Airline:</div>
                <div>Aircraft:</div>
                <div>Booking Class:</div>
                <div>Flight Number:</div>
                <div>Duration:</div>
              </div>
              <div className="space-y-1 text-base font-light text-black md:space-y-2">
                <div>Air Arabia</div>
                <div>{bookingDetails[index]?.aircraftModel} </div>
                <div>{cabin}</div>
                <div>{bookingDetails[index]?.classOfService?.code?.value}</div>
                <div>{bookingDetails[index]?.flightNumber}</div>
                <div>
                  {calculateTime(
                    flightInfo?.arrivalDateTime,
                    flightInfo?.departureDateTime
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderDetail = () => {
    if (!isOpen) return null;
    return (
      <div className="p-4 mx-6 border border-gray-900 shadow-lg md:p-8">
        {/* {cabinType[selectedCabin]?.map((items, index) => ( */}
        {flights.map((flightInfo, index) => {
          const showButton = index === flights?.length - 1;
          return (
            <div key={index}>
              {renderDetailTop(flightInfo, index, showButton)}
              {index === flights?.length - 1 ? null : (
                <div className="my-7 space-y-5 md:my-10">
                  <div className="border-t border-neutral-300" />
                  <div className="flex justify-between text-base font-light text-black">
                    {oneWayLength - 1 !== index ? (
                      "Transit time: Transit time: " +
                      calculateTime(
                        flights?.[index + 1]?.departureDateTime,
                        flights?.[index]?.arrivalDateTime
                      )
                    ) : (
                      <p className="text-sm font-light text-red-500">
                        Return Flight
                      </p>
                    )}
                  </div>
                  <div className="border-t border-neutral-300" />
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <div className="col-md-12">
        <div className="shadow-lg card">
          <div className="row">
            <div className="card-header">
              <div className="col-md-6">
                <h3 className="card-title">Flight Detail</h3>
              </div>
            </div>
          </div>
          <div className="card-body" data-nc-id="FlightCard">
            <div className={`relative sm:pr-20`} data-nc-id="FlightCard">
              <div className="row">
                <div className="col-md-4">
                  <div className="flex items-center space-x-2">
                    <div className="text-xl text-black">
                      <h1>
                        {moment(flights?.[0]?.departureDateTime).format(
                          "MMMM Do"
                        )}
                      </h1>
                      <h1>
                        {moment(flights?.[0]?.departureDateTime).format(
                          "HH:mm"
                        )}
                      </h1>
                      <h1 className="py-2 text-lg font-extralight">
                        {flights?.[0]?.departureAirport?.code}
                      </h1>
                    </div>
                  </div>
                </div>
                {/* {"->"} */}
                <div className="col-md-1">
                  <span className="flex justify-center w-12">
                    <i className="text-2xl las la-long-arrow-alt-right"></i>
                  </span>
                </div>
                <div className="col-md-4">
                  <div className="flex items-center space-x-2">
                    <div className="text-xl text-black">
                      <h1>
                        {moment(flights?.at(-1)?.arrivalDateTime).format(
                          "MMMM Do"
                        )}
                      </h1>
                      <h1>
                        {moment(flights?.at(-1)?.arrivalDateTime).format(
                          "HH:mm"
                        )}
                      </h1>
                      <h1 className="py-2 text-lg font-extralight">
                        {flights?.at(-1)?.arrivalAirport?.code}{" "}
                      </h1>
                    </div>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="flex items-center px-4 py-3 space-x-2">
                    <div className="text-lg text-black">
                      <h1 className="text-sm text-neutral-500 font-normal mt-0.5">
                        {calculateTime(
                          flights?.at(-1)?.arrivalDateTime,
                          flights?.at(0)?.departureDateTime
                        )}
                      </h1>
                      <h1>
                        {flights?.length > 1
                          ? flights?.length - 1 + " Stops"
                          : "Direct"}
                      </h1>
                    </div>
                  </div>
                </div>

                <div className="col-md-1">
                  <div className="flex items-center py-2 space-x-2">
                    <div className="flex-shrink-0 py-2 w-24 md:ml-10 lg:w-32">
                      <img src={airarabiaLogo} className="w-16" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-lg font-medium text-black">
              <span
                className={`absolute bottom-0 right-5 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-neutral-50 sm:bottom-auto sm:-translate-y-1/2 dark:bg-neutral-800 ${
                  isOpen ? "transform -rotate-180" : ""
                }`}
                onClick={() => setIsOpen(!isOpen)}
              >
                <i className="text-xl las la-angle-down"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="mt-1 mb-10 col-md-12">{renderDetail()}</div>
      </div>
    </>
  );
};

export default FlightPricingItemAirArabia;
